{
  "0095a9fa74": [
    {
      "type": 0,
      "value": "Export"
    }
  ],
  "00b177e080": [
    {
      "type": 0,
      "value": "Accept invitation"
    }
  ],
  "029f235f01": [
    {
      "type": 0,
      "value": "We’re working on support for files from "
    },
    {
      "children": [
        {
          "children": [
            {
              "type": 1,
              "value": "appName"
            }
          ],
          "type": 8,
          "value": "strong"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "043973ec1f": [
    {
      "type": 0,
      "value": "Still having trouble? "
    },
    {
      "type": 1,
      "value": "GetHelpLink"
    }
  ],
  "04a2dd56d6": [
    {
      "type": 0,
      "value": "Invite teammates"
    }
  ],
  "05b2656486": [
    {
      "children": [
        {
          "type": 1,
          "value": "author"
        }
      ],
      "type": 8,
      "value": "name"
    },
    {
      "type": 0,
      "value": " mentioned you"
    }
  ],
  "05f43078e9": [
    {
      "type": 0,
      "value": "You have reached the maximum number of workspaces. You need to delete old workspaces before creating new ones."
    }
  ],
  "06b9281e39": [
    {
      "type": 0,
      "value": "Auto"
    }
  ],
  "07dbd11b21": [
    {
      "type": 0,
      "value": "Untitled file"
    }
  ],
  "08331c1710": [
    {
      "type": 0,
      "value": "Rate limit exceeded, try again later."
    }
  ],
  "08bd40c754": [
    {
      "type": 0,
      "value": "Account"
    }
  ],
  "093ac7483a": [
    {
      "type": 0,
      "value": "Can’t open "
    },
    {
      "type": 1,
      "value": "extension"
    },
    {
      "type": 0,
      "value": " files yet"
    }
  ],
  "0a91f7fa87": [
    {
      "type": 0,
      "value": "This file has reached its size limit and changes might no longer be saved. Remove some content or start a new file."
    }
  ],
  "0b27918290": [
    {
      "type": 0,
      "value": "File"
    }
  ],
  "0b9a4cde72": [
    {
      "type": 0,
      "value": "File menu"
    }
  ],
  "0c4383617a": [
    {
      "type": 0,
      "value": "Something went wrong loading this invite. Please try again."
    }
  ],
  "0d1f2bb523": [
    {
      "type": 0,
      "value": "Send feedback"
    }
  ],
  "1063e38cb5": [
    {
      "type": 0,
      "value": "Remove"
    }
  ],
  "10fb1df194": [
    {
      "type": 0,
      "value": "Copy to personal workspace"
    }
  ],
  "110a4b01be": [
    {
      "type": 0,
      "value": "Publish"
    }
  ],
  "12a6766ba1": [
    {
      "type": 0,
      "value": "Unpin file"
    }
  ],
  "13ddd375ad": [
    {
      "type": 0,
      "value": "Export as"
    }
  ],
  "14b03eeeb5": [
    {
      "type": 0,
      "value": "Notification options"
    }
  ],
  "181b90f889": [
    {
      "type": 0,
      "value": "Create file"
    }
  ],
  "1da2e8106b": [
    {
      "type": 0,
      "value": "An unexpected error occurred."
    }
  ],
  "1dd1c5fb7f": [
    {
      "type": 0,
      "value": "Today"
    }
  ],
  "1ffd709937": [
    {
      "type": 0,
      "value": "A workspace must keep at least one owner. Make someone else an owner first."
    }
  ],
  "21f66c9c00": [
    {
      "type": 0,
      "value": "Workspace name"
    }
  ],
  "23dcace54a": [
    {
      "type": 0,
      "value": "You have been invited to join "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "workspaceName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Create a free account to continue."
    }
  ],
  "250ddea65c": [
    {
      "type": 0,
      "value": "About tldraw"
    }
  ],
  "2755e3ab39": [
    {
      "children": [
        {
          "type": 1,
          "value": "author"
        }
      ],
      "type": 8,
      "value": "name"
    },
    {
      "type": 0,
      "value": " commented on your board"
    }
  ],
  "28b2464e1f": [
    {
      "type": 0,
      "value": "Could not submit feedback"
    }
  ],
  "299cb00a7a": [
    {
      "type": 0,
      "value": "Upload failed"
    }
  ],
  "2a1167f869": [
    {
      "type": 0,
      "value": "Welcome to your workspace"
    }
  ],
  "2a37324bb4": [
    {
      "type": 0,
      "value": "Search..."
    }
  ],
  "2d3cdcfdd4": [
    {
      "type": 0,
      "value": "Please try again."
    }
  ],
  "2de510be71": [
    {
      "type": 0,
      "value": "Regenerating replaces the current invite link with a new one. Anyone using the old link will need the new one to join."
    }
  ],
  "2e2b3c700b": [
    {
      "type": 0,
      "value": "Include link to current file"
    }
  ],
  "2e9856a31e": [
    {
      "type": 0,
      "value": "Regenerate invite link"
    }
  ],
  "31246941ad": [
    {
      "type": 0,
      "value": "You need to sign in to view this file."
    }
  ],
  "31418ce4ad": [
    {
      "type": 0,
      "value": "i18n: Highlight Missing"
    }
  ],
  "324a0f3182": [
    {
      "type": 0,
      "value": "Back to tldraw"
    }
  ],
  "335defdafe": [
    {
      "type": 0,
      "value": "Please try refreshing the page."
    }
  ],
  "344a7f427f": [
    {
      "type": 0,
      "value": "Editor"
    }
  ],
  "34e34c43ec": [
    {
      "type": 0,
      "value": "Manage"
    }
  ],
  "375396d6e5": [
    {
      "type": 0,
      "value": "Remove member"
    }
  ],
  "3bc7d6ea2f": [
    {
      "type": 0,
      "value": "Continue with email"
    }
  ],
  "3bd1b98dbd": [
    {
      "type": 0,
      "value": "Unable to publish the changes."
    }
  ],
  "3c5e891bff": [
    {
      "type": 0,
      "value": "Pinned"
    }
  ],
  "3d0238bf16": [
    {
      "type": 0,
      "value": "Accept all"
    }
  ],
  "3e2ae04ff0": [
    {
      "type": 0,
      "value": "Unsupported Mermaid diagram"
    }
  ],
  "402bf0c47e": [
    {
      "type": 0,
      "value": "Color theme"
    }
  ],
  "42e53c47c1": [
    {
      "type": 0,
      "value": "Contact the owner to request access."
    }
  ],
  "44db318ee5": [
    {
      "type": 0,
      "value": "Get help on Discord"
    }
  ],
  "454aad3b3c": [
    {
      "type": 0,
      "value": "Are you sure you want to delete "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "fileName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": "?"
    }
  ],
  "46137245cd": [
    {
      "type": 0,
      "value": "Thanks for helping us improve tldraw!"
    }
  ],
  "46de2de6bb": [
    {
      "type": 0,
      "value": "Accept terms of use"
    }
  ],
  "477df802ca": [
    {
      "type": 0,
      "value": "To continue editing please copy the file to your files."
    }
  ],
  "47f493a590": [
    {
      "type": 0,
      "value": "Pin file"
    }
  ],
  "49ee308734": [
    {
      "type": 0,
      "value": "Name"
    }
  ],
  "4d0d3ddec9": [
    {
      "type": 0,
      "value": "This site uses cookies to make the app work and to collect analytics."
    }
  ],
  "4d1c8263ba": [
    {
      "type": 0,
      "value": "Reload"
    }
  ],
  "5097d89907": [
    {
      "type": 0,
      "value": "Unsupported diagram, will generate SVG instead"
    }
  ],
  "50db1b7e1e": [
    {
      "type": 0,
      "value": "Unable to unpublish the file."
    }
  ],
  "51317dcad5": [
    {
      "type": 0,
      "value": "This is your private workspace. Create a new workspace to invite teammates."
    }
  ],
  "517bb809d9": [
    {
      "type": 0,
      "value": "Page menu"
    }
  ],
  "53770fd374": [
    {
      "type": 0,
      "value": "Unread"
    }
  ],
  "542248f0ba": [
    {
      "type": 0,
      "value": "This file is now read-only"
    }
  ],
  "54286b1d01": [
    {
      "type": 0,
      "value": "Collaborator limit reached"
    }
  ],
  "550b25cc0c": [
    {
      "type": 0,
      "value": "Could not restore your local drawing. Try reloading this page."
    }
  ],
  "554a05155c": [
    {
      "type": 0,
      "value": "Still having trouble? "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Report a problem"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "55505ba281": [
    {
      "type": 0,
      "value": "PNG"
    }
  ],
  "5638176be5": [
    {
      "type": 0,
      "value": "Create a workspace"
    }
  ],
  "5677e381d2": [
    {
      "type": 0,
      "value": "We use analytics cookies to make tldraw better."
    }
  ],
  "56c34c6410": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "5a95a425f7": [
    {
      "type": 0,
      "value": "Share"
    }
  ],
  "5bec508475": [
    {
      "type": 0,
      "value": "Old browser detected. Please update your browser to use this app."
    }
  ],
  "5bff3c9c88": [
    {
      "type": 0,
      "value": "My workspace"
    }
  ],
  "5bffeebf03": [
    {
      "children": [
        {
          "type": 1,
          "value": "author"
        }
      ],
      "type": 8,
      "value": "name"
    },
    {
      "type": 0,
      "value": " reacted to your comment"
    }
  ],
  "5d04a002ea": [
    {
      "type": 0,
      "value": "Unable to connect"
    }
  ],
  "5d26ae7550": [
    {
      "type": 0,
      "value": "We failed to upload some of the content you created before you signed in."
    }
  ],
  "5f3c333678": [
    {
      "type": 0,
      "value": "Feedback submitted"
    }
  ],
  "5fb63579fc": [
    {
      "type": 0,
      "value": "Copy"
    }
  ],
  "608e9d366e": [
    {
      "type": 0,
      "value": "You’re all caught up."
    }
  ],
  "60a68c29d6": [
    {
      "type": 0,
      "value": "Sign in to comment"
    }
  ],
  "61057a0c84": [
    {
      "type": 0,
      "value": "Later"
    }
  ],
  "61fb03fd7b": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "Someone reacted to your comment"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " people reacted to your comment"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "625fd29749": [
    {
      "type": 0,
      "value": "Older"
    }
  ],
  "639bae9ac6": [
    {
      "type": 0,
      "value": "you"
    }
  ],
  "63a6a88c06": [
    {
      "type": 0,
      "value": "Refresh"
    }
  ],
  "6609dd239e": [
    {
      "type": 0,
      "value": "Something went wrong"
    }
  ],
  "6637a98151": [
    {
      "type": 0,
      "value": "A new version of tldraw is available. Please reload the page to continue."
    }
  ],
  "681e10aecb": [
    {
      "type": 0,
      "value": "New file"
    }
  ],
  "6832ac5936": [
    {
      "type": 0,
      "value": "Enter your email address"
    }
  ],
  "694f82ed9d": [
    {
      "type": 0,
      "value": "Delete workspace"
    }
  ],
  "6a26f54883": [
    {
      "type": 0,
      "value": "Help"
    }
  ],
  "6dc0836c1b": [
    {
      "type": 0,
      "value": "You do not have the necessary permissions to perform this action."
    }
  ],
  "6dfc62f621": [
    {
      "type": 0,
      "value": "Follow these steps to import the content manually:"
    }
  ],
  "70a6facb9d": [
    {
      "type": 0,
      "value": "This week"
    }
  ],
  "71a29b007b": [
    {
      "type": 0,
      "value": "Have a bug, issue, or idea for tldraw? Let us know!"
    }
  ],
  "73ab799383": [
    {
      "type": 0,
      "value": "This version of tldraw is no longer supported."
    }
  ],
  "7408cf0d7b": [
    {
      "type": 0,
      "value": "Please reload the page"
    }
  ],
  "74ff4bad28": [
    {
      "type": 0,
      "value": "No files found"
    }
  ],
  "752b79f137": [
    {
      "type": 0,
      "value": "You have reached the maximum number of files. You need to delete old files before creating new ones."
    }
  ],
  "7542d62aac": [
    {
      "type": 0,
      "value": "Mark all as read"
    }
  ],
  "7573b8110a": [
    {
      "type": 0,
      "value": "No access"
    }
  ],
  "761e93ede9": [
    {
      "type": 0,
      "value": "Manage cookies"
    }
  ],
  "764671e008": [
    {
      "type": 0,
      "value": "Chat with us on Discord"
    }
  ],
  "7697920637": [
    {
      "type": 0,
      "value": "Please reload"
    }
  ],
  "777f9e90cf": [
    {
      "type": 0,
      "value": "Invalid request."
    }
  ],
  "7827371d1a": [
    {
      "type": 0,
      "value": "This anonymous tldraw multiplayer file is now read-only. To continue editing, please sign in and copy it to your files."
    }
  ],
  "78e9815992": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "797799f35e": [
    {
      "type": 0,
      "value": "Submit an issue on GitHub"
    }
  ],
  "7a1920d611": [
    {
      "type": 0,
      "value": "Default"
    }
  ],
  "7b1329f5ca": [
    {
      "type": 0,
      "value": "User manual"
    }
  ],
  "7be10fc592": [
    {
      "type": 0,
      "value": "Restore version"
    }
  ],
  "7c0747a5df": [
    {
      "type": 0,
      "value": "Open tldraw"
    }
  ],
  "7cb5f8b4a5": [
    {
      "type": 0,
      "value": "Forget"
    }
  ],
  "7daeced9ff": [
    {
      "type": 0,
      "value": "Publish changes"
    }
  ],
  "7fcdcc6455": [
    {
      "type": 0,
      "value": "Forget file"
    }
  ],
  "801ab24683": [
    {
      "type": 0,
      "value": "Download"
    }
  ],
  "8030793ce3": [
    {
      "type": 0,
      "value": "New workspace"
    }
  ],
  "815e116a2e": [
    {
      "type": 0,
      "value": "Have a bug, issue, or idea for tldraw? Let us know! Fill out this form and we will follow up over email if needed. You can also "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "chat with us on Discord"
        }
      ],
      "type": 8,
      "value": "discord"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "submit an issue on GitHub"
        }
      ],
      "type": 8,
      "value": "github"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "81666c6e4a": [
    {
      "type": 0,
      "value": "Are you sure you want to forget "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "fileName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": "?"
    }
  ],
  "8413c683b4": [
    {
      "type": 0,
      "value": "Comments"
    }
  ],
  "858ba4765e": [
    {
      "type": 0,
      "value": "Member"
    }
  ],
  "85a082de1b": [
    {
      "type": 0,
      "value": "Please refresh the page to get the latest version of tldraw."
    }
  ],
  "86c66437fd": [
    {
      "type": 0,
      "value": "Rename file"
    }
  ],
  "87fdb09de6": [
    {
      "type": 0,
      "value": "You are already a member of this workspace"
    }
  ],
  "88bf6ab42c": [
    {
      "type": 0,
      "value": "This invite link has expired"
    }
  ],
  "8c2d3d730c": [
    {
      "type": 0,
      "value": "Check your email for a verification code."
    }
  ],
  "8eb2c00e96": [
    {
      "type": 0,
      "value": "Shared with you"
    }
  ],
  "8ff3d0a705": [
    {
      "type": 0,
      "value": "Rate limited"
    }
  ],
  "902b0d55fd": [
    {
      "type": 0,
      "value": "Error"
    }
  ],
  "904a830405": [
    {
      "type": 0,
      "value": "Rename"
    }
  ],
  "90646db02d": [
    {
      "type": 0,
      "value": "Are you sure you want to delete "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "workspaceName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": "? This action cannot be undone."
    }
  ],
  "95aacd4d4a": [
    {
      "type": 0,
      "value": "Sign in with Google"
    }
  ],
  "95d2109dc8": [
    {
      "type": 0,
      "value": "Build with the tldraw SDK"
    }
  ],
  "96165d6df5": [
    {
      "type": 0,
      "value": "This month"
    }
  ],
  "985a4b720f": [
    {
      "type": 0,
      "value": "Terms of Use"
    }
  ],
  "9914a0ce04": [
    {
      "type": 0,
      "value": "Light"
    }
  ],
  "9983381c21": [
    {
      "type": 0,
      "value": "Clear search"
    }
  ],
  "9b33f5c63c": [
    {
      "type": 0,
      "value": "Didn’t receive a code? "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Resend"
        }
      ],
      "type": 8,
      "value": "resend"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "9bef626805": [
    {
      "type": 0,
      "value": "Delete file"
    }
  ],
  "9c228b6834": [
    {
      "type": 0,
      "value": "You appear to be offline. Check your connection and try again."
    }
  ],
  "9ccb565b86": [
    {
      "type": 0,
      "value": "We're having trouble connecting to our authentication service. This is usually temporary. Please try refreshing the page."
    }
  ],
  "9ceb927baa": [
    {
      "type": 0,
      "value": "Publish this file"
    }
  ],
  "9e076f5885": [
    {
      "type": 0,
      "value": "Not found"
    }
  ],
  "9e93c98d88": [
    {
      "type": 0,
      "value": "Opt out"
    }
  ],
  "a078644c42": [
    {
      "type": 0,
      "value": "You have been invited to join "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "workspaceName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "a0a19d5145": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " unread"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " unread"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "a0da245992": [
    {
      "type": 0,
      "value": "Export the content as a .tldr file: Select 'Download' in the top left menu."
    }
  ],
  "a104439641": [
    {
      "type": 0,
      "value": "Padding"
    }
  ],
  "a18366b217": [
    {
      "type": 0,
      "value": "Dark"
    }
  ],
  "a1c915578c": [
    {
      "type": 0,
      "value": "The file you are looking for does not exist."
    }
  ],
  "a239905023": [
    {
      "type": 0,
      "value": "Export image"
    }
  ],
  "a274f4d467": [
    {
      "type": 0,
      "value": "Notifications"
    }
  ],
  "a3debabee7": [
    {
      "type": 0,
      "value": "Cookie policy"
    }
  ],
  "a4d3b161ce": [
    {
      "type": 0,
      "value": "Submit"
    }
  ],
  "a52945dbe2": [
    {
      "type": 0,
      "value": "Leave"
    }
  ],
  "a6cc403d56": [
    {
      "type": 0,
      "value": "Anyone with the link"
    }
  ],
  "a768caa988": [
    {
      "type": 0,
      "value": "Analytics"
    }
  ],
  "a8873770ab": [
    {
      "type": 0,
      "value": "File is getting large"
    }
  ],
  "a9ded1e5ce": [
    {
      "type": 0,
      "value": "Background"
    }
  ],
  "aac449eef6": [
    {
      "type": 0,
      "value": "Create workspace"
    }
  ],
  "aaec8f7cde": [
    {
      "type": 0,
      "value": "Someone"
    }
  ],
  "ab0df9ba36": [
    {
      "type": 0,
      "value": "File limit reached"
    }
  ],
  "af3dc88931": [
    {
      "type": 0,
      "value": "Last published "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "date"
    }
  ],
  "b028909917": [
    {
      "type": 0,
      "value": "Guest user"
    }
  ],
  "b03400e2db": [
    {
      "children": [
        {
          "type": 1,
          "value": "author"
        }
      ],
      "type": 8,
      "value": "name"
    },
    {
      "type": 0,
      "value": " replied"
    }
  ],
  "b1c94ca2fb": [
    {
      "type": 0,
      "value": "All"
    }
  ],
  "b2326c3a34": [
    {
      "type": 0,
      "value": "Regenerate"
    }
  ],
  "b2c3c2e30c": [
    {
      "type": 0,
      "value": "File is full"
    }
  ],
  "b357b524e7": [
    {
      "type": 0,
      "value": "Email address"
    }
  ],
  "b48becc771": [
    {
      "type": 0,
      "value": "Enable invites"
    }
  ],
  "b6d4223e60": [
    {
      "type": 0,
      "value": "Sign in"
    }
  ],
  "b6f4a2ec63": [
    {
      "type": 0,
      "value": "Owner"
    }
  ],
  "b74dbb40c5": [
    {
      "type": 0,
      "value": "Drag the file into the sidebar on this page. Or select the 'Import file' option from the File menu in the top left."
    }
  ],
  "b758336699": [
    {
      "type": 0,
      "value": "Copy link"
    }
  ],
  "ba0318cb81": [
    {
      "type": 0,
      "value": "Sign in to share"
    }
  ],
  "bbaaf8b6bf": [
    {
      "type": 0,
      "value": "Invites are disabled"
    }
  ],
  "bbbcefd7ce": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "Uploading .tldr file…"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Uploading "
            },
            {
              "type": 1,
              "value": "uploaded"
            },
            {
              "type": 0,
              "value": " of "
            },
            {
              "type": 1,
              "value": "total"
            },
            {
              "type": 0,
              "value": " .tldr files…"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "total"
    }
  ],
  "bc88b0e89e": [
    {
      "type": 0,
      "value": "Shared by "
    },
    {
      "type": 1,
      "value": "ownerName"
    }
  ],
  "c17466812d": [
    {
      "type": 0,
      "value": "Manage workspace"
    }
  ],
  "c2276c9127": [
    {
      "type": 0,
      "value": "Learn more about sharing."
    }
  ],
  "c26f17786f": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "Added "
            },
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " .tldr file."
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Added "
            },
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " .tldr files."
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "total"
    }
  ],
  "c303bd1095": [
    {
      "type": 0,
      "value": "Unable to publish the file."
    }
  ],
  "c4b39a1cc3": [
    {
      "type": 0,
      "value": "Essential cookies"
    }
  ],
  "c6a00f137b": [
    {
      "type": 0,
      "value": "Invite"
    }
  ],
  "c6f16003f2": [
    {
      "type": 0,
      "value": "Copy to my workspace"
    }
  ],
  "c87aacf567": [
    {
      "type": 0,
      "value": "Sign out"
    }
  ],
  "c8a59e7135": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "cceaefbc20": [
    {
      "type": 0,
      "value": "Share this file"
    }
  ],
  "cd15a75c26": [
    {
      "type": 0,
      "value": "SVG"
    }
  ],
  "ce0547606c": [
    {
      "type": 0,
      "value": "This file is approaching its size limit. Consider removing some content or starting a new file."
    }
  ],
  "cea291e45e": [
    {
      "type": 0,
      "value": "Learn more about publishing."
    }
  ],
  "d0e3556476": [
    {
      "children": [
        {
          "type": 1,
          "value": "author"
        }
      ],
      "type": 8,
      "value": "name"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " other"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " others"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    },
    {
      "type": 0,
      "value": " reacted to your comment"
    }
  ],
  "d3d2e61733": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "d46632fe1f": [
    {
      "type": 0,
      "value": "Too many requests. Please slow down."
    }
  ],
  "d4bbf74f3e": [
    {
      "type": 0,
      "value": "Toggle sidebar"
    }
  ],
  "d638a3344b": [
    {
      "type": 0,
      "value": "Before you start, please accept our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "terms of use"
        }
      ],
      "type": 8,
      "value": "tos"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "privacy policy"
        }
      ],
      "type": 8,
      "value": "privacy"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "d721757161": [
    {
      "type": 0,
      "value": "Theme"
    }
  ],
  "d876a9fe1a": [
    {
      "type": 0,
      "value": "Try Again"
    }
  ],
  "d88ad2dc74": [
    {
      "type": 0,
      "value": "Accept and continue"
    }
  ],
  "d9100f3e10": [
    {
      "type": 0,
      "value": "Go here to see the content"
    }
  ],
  "dbbebf3c03": [
    {
      "type": 0,
      "value": "Invite only"
    }
  ],
  "dbf9b24193": [
    {
      "type": 0,
      "value": "Leave workspace"
    }
  ],
  "dfdb78a4e4": [
    {
      "type": 0,
      "value": "App debug flags"
    }
  ],
  "e0aa021e21": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "e2198d6228": [
    {
      "type": 0,
      "value": "Copy invite link"
    }
  ],
  "e2ae80a510": [
    {
      "type": 0,
      "value": "Legal summary"
    }
  ],
  "e404559826": [
    {
      "type": 0,
      "value": "Terms of service"
    }
  ],
  "e65b2dcb6f": [
    {
      "children": [
        {
          "type": 1,
          "value": "a"
        }
      ],
      "type": 8,
      "value": "name"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "b"
        }
      ],
      "type": 8,
      "value": "name"
    },
    {
      "type": 0,
      "value": " reacted to your comment"
    }
  ],
  "e81c4e4f2b": [
    {
      "type": 0,
      "value": "or"
    }
  ],
  "ea4788705e": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "eb1e2b0542": [
    {
      "type": 0,
      "value": "Ask the workspace owner for a new one."
    }
  ],
  "ebfe9ce86e": [
    {
      "type": 0,
      "value": "Yesterday"
    }
  ],
  "ec59b960ea": [
    {
      "type": 0,
      "value": "This file has reached the maximum number of active collaborators."
    }
  ],
  "ec611e9a08": [
    {
      "type": 0,
      "value": "Account menu"
    }
  ],
  "ed75712b0e": [
    {
      "type": 0,
      "value": "Duplicate"
    }
  ],
  "ede55d955f": [
    {
      "type": 0,
      "value": "Read our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "cookie policy"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " to learn more."
    }
  ],
  "edec9387f9": [
    {
      "type": 0,
      "value": "This comment was deleted."
    }
  ],
  "ef53538ae4": [
    {
      "type": 0,
      "value": "Members"
    }
  ],
  "ef7de3f485": [
    {
      "type": 0,
      "value": "selected"
    }
  ],
  "f09b16bc5f": [
    {
      "type": 0,
      "value": "We use cookies to keep you logged in, to sync your files, and to collect analytics to help us improve tldraw."
    }
  ],
  "f0e8bff6f9": [
    {
      "type": 0,
      "value": "User settings"
    }
  ],
  "f2569594b2": [
    {
      "type": 0,
      "value": "We use these cookies to save your files and settings."
    }
  ],
  "f2a6c498fb": [
    {
      "type": 0,
      "value": "Delete"
    }
  ],
  "f476ba8646": [
    {
      "children": [
        {
          "type": 1,
          "value": "a"
        }
      ],
      "type": 8,
      "value": "name"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "b"
        }
      ],
      "type": 8,
      "value": "name"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " other"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " others"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    },
    {
      "type": 0,
      "value": " reacted to your comment"
    }
  ],
  "f4f70727dc": [
    {
      "type": 0,
      "value": "Settings"
    }
  ],
  "f5ddc8d9c1": [
    {
      "type": 0,
      "value": "For now, you can "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "export as a "
        },
        {
          "type": 1,
          "value": "extension"
        },
        {
          "type": 0,
          "value": " file"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " to use it here."
    }
  ],
  "fa2ead697d": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "fb15c53f22": [
    {
      "type": 0,
      "value": "Viewer"
    }
  ],
  "fc9d47046b": [
    {
      "type": 0,
      "value": "Are you sure you want to leave this workspace?"
    }
  ],
  "fed5ec05eb": [
    {
      "type": 0,
      "value": "Copied link"
    }
  ],
  "ff2fefd3c6": [
    {
      "type": 0,
      "value": "Are you sure you want to remove "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " from this workspace?"
    }
  ],
  "ff52811b98": [
    {
      "type": 0,
      "value": "Create a free account to save your files and tldraw with your teammates."
    }
  ],
  "ffcd73e997": [
    {
      "type": 0,
      "value": "Import file…"
    }
  ]
}